import { Metadata } from '../../../../utils/spds/metadata';
import Super from '../../core/button.gjs';
import styles from './ghost.module.scss';

const METADATA = Metadata.define({
  description: `
    Ghost button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Ghost Button',
});

export default class SpdsActionButtonGhost extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-ghost';
  variantStyles = styles;
}

export const ACTION_BUTTON_GHOST_METADATA = SpdsActionButtonGhost.metadata;
